import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import DropdownSelect from '@/components/fields/DropdownSelect';
import Field from '@/components/fields/Field';
import { LOCALES } from '@/i18n';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation(['onboarding', 'common']);

  const languageOptions = useMemo(
    () =>
      LOCALES.map(locale => ({
        value: locale,
        label: t(`common:langs.${locale}`)
      })),
    [t]
  );

  return (
    <Field
      name="language"
      component={DropdownSelect}
      label={t('onboarding.selectLanguage')}
      withFormControl
      outerSx={{
        p: 0,
        minWidth: 180
      }}
      innerProps={{
        options: languageOptions,
        isMulti: false,
        isSearchable: false,
        sx: {
          minWidth: 180
        }
      }}
      onChange={value => {
        const lang = value as string;
        i18n.changeLanguage(lang);
      }}
    />
  );
};

export default LanguageSelector;
